/**
 * Get CSS styles of a given element in name-value pair format
 * @param element The element to get styles from
 */
export default function getStyles(element) {
    var result = {};
    var style = (element === null || element === void 0 ? void 0 : element.getAttribute('style')) || '';
    style.split(';').forEach(function (pair) {
        var valueIndex = pair.indexOf(':');
        var name = pair.slice(0, valueIndex);
        var value = pair.slice(valueIndex + 1);
        if (name && value) {
            result[name.trim()] = value.trim();
        }
    });
    return result;
}
//# sourceMappingURL=getStyles.js.map